import { Box } from '@mui/material';
import Slide from '@mui/material/Slide';
import * as Preact from 'preact';
import * as Image from './A_LoadingMainImage';
import * as InfoContainer from './M_LoadingInfoContainer';

export interface Props {
    show: boolean;
    logoUrl?: string;
    loadingImage: string;
    configuratorType: string;
    optionType: string;
}

export const Component = (p: Props) => {
    return (
        <Slide in={p.show} appear={false} timeout={{ enter: 0, exit: 350 }} direction="up">
            <Box
                sx={{
                    position: 'absolute',
                    display: { xs: 'flex', sm: 'grid' },
                    flexDirection: { xs: 'column-reverse' },
                    gridTemplateColumns: { sm: '320px 1fr' },
                    gap: { xs: '24px', sm: '48px' },
                    padding: { xs: '24px', sm: '32px 32px 32px 48px' },
                    backgroundColor: '#F8F8F8',
                    width: '100%',
                    height: '100%',
                    boxSizing: 'border-box',
                    zIndex: 'modal',
                }}
            >
                <InfoContainer.Component
                    logoUrl={p.logoUrl}
                    configuratorType={p.configuratorType}
                    optionType={p.optionType}
                />
                <Image.Component imageUrl={p.loadingImage} />
            </Box>
        </Slide>
    );
};

Component.displayName = 'LoadingScreen';
